import React from "react";
import { Result } from "antd";
import image from "assets/images/account_closed.png";
import { useTranslation } from "react-i18next";
const AccountClosed = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        icon={<img style={{ width: "80%", maxWidth: "250px" }} src={image} alt="unhappy" />}
        title={t("accountClosed.title")}
        subTitle={t("accountClosed.subTitle")}
      />
    </>
  );
};

export default AccountClosed;
